import { useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { FaCheck, FaRegCopy } from 'react-icons/fa';

const CopyText = ({ text, title }) => {
    const [isShowCopied, setIsShowCopied] = useState(false);

    const handleShowCopied = () => {
        setIsShowCopied((c) => !c);
        setTimeout(() => {
            setIsShowCopied((c) => !c);
        }, 1500);
    };

    return (
        <CopyToClipboard onCopy={handleShowCopied} text={text} title={title || 'Copy text'}>
            <button className="btn btn-link py-0 pr-0 pl-1 my-0" disabled={isShowCopied}>
                {isShowCopied ? <FaCheck /> : <FaRegCopy />}
            </button>
        </CopyToClipboard>
    );
};

export default CopyText;
